// Maps demo scenario IDs to their hero images
export const SCENARIO_IMAGES = {
  sepsis: "/scenarios/sepsis.png",
  amr: "/scenarios/amr.png",
  ovarian: "/scenarios/ovarian.png",
  maternal: "/scenarios/maternal.png",
  tb: "/scenarios/tb.png",
};

// Maps known venture run_ids to their dedicated hero images
export const VENTURE_HERO_IMAGES = {
  "fc526bce-d199-433b-8475-8ba28829527f": "/scenarios/firstmile-sepsis-hero.png",
  "ee0c66ab-8d48-4614-9054-dd33b09c160d": "/scenarios/zonesight-hero.png",
};

// Returns a hero image URL for a venture, or null if none mapped
export function ventureHeroFor(runId) {
  return VENTURE_HERO_IMAGES[runId] || null;
}
